import React, { useState } from "react";
import LoadingButton from "../../dumb/LoadingButton";
import useModal from "../../../hook/useModal";
import DisplayError from "../../dumb/DisplayError";
import useStatusThunk from "../../../hook/useStatusThunk";
import { finishTask } from "../../../redux/ducks/task";

const FinishTask = props => {
    const [show, hide, renderModal] = useModal();
    const [d_finishTask, status, error, event] = useStatusThunk(finishTask);

    event.onSuccess = () => hide();

    return (
        <React.Fragment>
            <button className={"button button--primary " + props.className + " " + (!props.taskID ? "button--disabled" : "")} onClick={show}>Finish</button>

            {renderModal(
                <React.Fragment>

                    <div className="group">
                        <DisplayError error={error} />
                    </div>

                    <LoadingButton loading={status == "pending"} className="button--primary" onClick={() => { d_finishTask({ taskID: props.taskID }) }}>Finish Task</LoadingButton>
                </React.Fragment>
            )}
        </React.Fragment>
    )
}

export default FinishTask;